import type { ReactNode } from "react";
import ScoutMark from "@/components/ScoutMark";

type AuthShellProps = {
  children: ReactNode;
};

export default function AuthShell({ children }: AuthShellProps) {
  return (
    <main className="flex min-h-screen items-center justify-center bg-gray-25 px-6 py-12">
      <div className="w-full max-w-lg space-y-8">
        <ScoutMark variant="icon" className="mx-auto h-12 w-12" label="ScoutUX" />
        {children}
      </div>
    </main>
  );
}
